/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData } from '@gh/common-shared';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { SystemVarsSupervisor } from '../../resources/model/system-vars-supervisor.model';

import { SystemVarsSupervisorTabBusinessService } from '../../resources/system-vars-supervisor-tab-business.service';
import { SystemVarsSupervisorTabFormState } from './system-vars-supervisor-tab-form.service';

@Component({
  standalone: false,
  selector: 'gh-system-vars-supervisor-tab',
  templateUrl: 'system-vars-supervisor-tab.component.html',
  styleUrls: ['system-vars-supervisor-tab.component.scss'],
  viewProviders: [
    SystemVarsSupervisorTabFormState,
  ],
})
export class SystemVarsSupervisorTabComponent extends AbstractFormComponent<SystemVarsSupervisor> implements OnInit {
  private supervisorSystemVariables: SystemVarsSupervisor;

  constructor(public form: SystemVarsSupervisorTabFormState,
              private route: ActivatedRoute,
              private businessService: SystemVarsSupervisorTabBusinessService,
              private navigationService: BuilderNavigationService,
              private dialogService: DialogService,
              private userContext: BuilderUserContext,
              private pipelines: FormActionPipelines,
              private actions: CommonActions) {
    super();
  }

  ngOnInit(): void {
    const { supervisorSystemVariables } = getRouteInitData(this.route);
    this.supervisorSystemVariables = supervisorSystemVariables;
    this.form.build(supervisorSystemVariables);
  }

  get completeFlow(): ActionFlow<FormFlowState<SystemVarsSupervisor>> {
    return this.pipelines.complete({
      execute: this.actions.execute(({ value }: FormFlowState<SystemVarsSupervisor>) =>
        this.businessService.update(value)),
      finish: ({ value }: FormFlowState<SystemVarsSupervisor>) => {
        this.supervisorSystemVariables = value;
        this.form.build(value);
      },
    });
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => this.form.build(this.supervisorSystemVariables));
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.userContext.office && this.userContext.office.id,
      entityType: 'OFFICE',
      eventTypeIds: [AelEvents.Office.EditedSupervisor],
      label: 'lbl_supervisor',
    });
  }
}
